import ActionTypes from '../../../../../ActionsTypes';
export function setCurrentDateRange(countryID, plotID, data) {
  return {
    type: ActionTypes.SET_CURRENT_DATE_RANGE,
    payload: {
      countryID: countryID,
      plotID: plotID,
      data: data
    }
  };
}
export function setTotalDateRange(countryID, plotID, data) {
  return {
    type: ActionTypes.SET_TOTAL_DATE_RANGE,
    payload: {
      countryID: countryID,
      plotID: plotID,
      data: data
    }
  };
}
export function updateDateRange(countryID, plotID, data) {
  return {
    type: ActionTypes.UPDATE_DATE_RANGE,
    payload: {
      countryID: countryID,
      plotID: plotID,
      data: data
    }
  };
}